<!--
  <p *ngIf="i + 1 < active" [class.done]></p>
    <p *ngIf="i + 1 < active"></p>
    <p *ngIf="i + 1 < active"></p>
 -->
<div class="chain-container" *ngIf="length">
  <div class="progress"  style="height: 5px; position: absolute; width:100%">
    <div
      class="progress-bar"
      role="progressbar"
      [style.maxWidth]="((active - 1) / (length - 1)) * 100 + '%'"
      style="
        background: linear-gradient(
          180deg,
          #92c93e 0%,
          #6ebf46 100%
        ) !important;
        width: 100%;
        transition: all 0.3s ease !important;
      "
    ></div>
  </div>
  <div class="cet-points" *ngIf="!mydata">
    <ng-container *ngFor="let item of [].constructor(length); let i = index">
      <span class="custom-checkBox accepted" *ngIf="i + 1 < active">
        <img src="assets/images/check.svg" alt="done" />
      </span>
      <span class="custom-checkBox active" *ngIf="i + 1 == active">
        {{ i + 1 }}
      </span>
      <span class="custom-checkBox gray" *ngIf="i + 1 > active">
        {{ i + 1 }}
      </span>
    </ng-container>
  </div>
  <div class="cet-points" *ngIf="mydata">
    <ng-container *ngFor="let item of [].constructor(length); let i = index">
      <!-- *ngIf="i + 1 < active -->
      <span class="custom-checkBox accepted" *ngIf="i + 1 < active && mydata[i].completed">
        <img src="assets/images/check.svg" alt="done" />
      </span>
      <span class="custom-checkBox gray" *ngIf="i + 1 < active && !mydata[i].completed">
        {{ i + 1 }}
      </span>
      <span class="custom-checkBox active" *ngIf="i + 1 == active">
        {{ i + 1 }}
      </span>
      <span class="custom-checkBox gray" *ngIf="i + 1 > active && !mydata[i].completed">
        {{ i + 1 }}
      </span>
      <span class="custom-checkBox accepted" *ngIf="i + 1 > active && mydata[i].completed">
        <img src="assets/images/check.svg" alt="done" />
      </span>
    </ng-container>
  </div>
</div>
